import axios from 'axios'
import config from './config'
import * as composable from './composable'

const user = composable.useUser()

// define axios instance for api requests
const xhr = axios.create({
  baseURL: config.baseUrl.api,
})

// add a response interceptor to handle 401 errors
xhr.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      console.error("[XHR] 401 Unauthorized detected. Clearing session.");
      // Avoid redirect loops if we're already on login/me
      if (!error.config.url.includes('/api/auth/local') && !error.config.url.includes('/api/users/me')) {
        user.logout();
      }
    }
    return Promise.reject(error);
  }
);

// add the jwt to each request if present in config
xhr.interceptors.request.use(
  function (req) {
    if (user.jwt.value) {
      console.log(`[XHR] ${req.method?.toUpperCase()} ${req.url} (Token attached)`);
      req.headers.set('Authorization', `Bearer ${user.jwt.value}`);
    } else {
      console.warn(`[XHR] ${req.method?.toUpperCase()} ${req.url} (NO TOKEN FOUND)`);
    }
    return req;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default xhr